import { DateTime } from 'luxon'
import { BaseService } from '../BaseService'

export const DEFAULT_STEP_INTERVAL_MINUTES = 5 as const

export class DateTimeService extends BaseService {
  /**
   * Maps the {@code datetime} to UTC, then rounds it to the latest step interval (in minutes),
   * e.g., 5 minutes, 60 minutes, 120 minutes, etc.
   *
   * @param datetime an optional datetime. If {@code datetime === null} it is replaced by {@code DateTime.now()}
   * @param stepInterval optional step size in minutes (defaults to {@link DEFAULT_STEP_INTERVAL_MINUTES})
   * @return a datetime with 0 second and 0 millisecond, rounded down to the closest step interval
   */
  public getUtcRounded(datetime?: DateTime, stepInterval: number = DEFAULT_STEP_INTERVAL_MINUTES): DateTime {
    const dt = (datetime ?? DateTime.now()).toUTC()

    const totalMinutes = dt.hour * 60 + dt.minute
    const roundedMinutes = stepInterval * Math.floor(totalMinutes / stepInterval)

    const roundedHour = Math.floor(roundedMinutes / 60)
    const roundedMinute = roundedMinutes % 60

    return dt.set({
      hour: roundedHour,
      minute: roundedMinute,
      second: 0,
      millisecond: 0,
    })
  }
}
